module.exports = __webpack_public_path__ + "media/images/homepage/right-vector-eb562a5655142e4d89d3eb5f5ae96484.jpg";